/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Share audience: email
  shareAudienceEmail: "",
  selectedAudience: null,
  isValidateLoading: false,
  isShareValidateEmailSuccess: false,
  shareValidateEmailError: null,

  // Share audience: modal
  isShareAudienceModalOpen: false,

  // Share audience: profile to share with
  profileToShareWith: null,
  isProfileToShareWithLoading: false,

  // Share audience
  isShareAudienceLoading: false,
  isShareAudienceSuccess: false,
  shareError: null,

  // Duplicate audience
  isDublicateSuccess: false,
  isDubliciting: false,

  // Removed audiences
  removedAudiences: [],
  isRemovedAudiencesLoading: false,
  isRestoreAllAudiencesSuccess: false,
  isRestoreAudienceSuccess: false,
  isPermanentRemoveAllSuccess: false,

  // Map
  mapLayouts: {},
  isMapLayoutLoading: false,
  mapFetchLayoutError: null
};

const audience = createSlice({
  name: "audience_slice",
  initialState,
  reducers: {
    // Share audience: modal
    showShareAudienceModal(state, { payload }) {
      state.isShareAudienceModalOpen = true;
      state.selectedAudience = payload;
    },
    hideShareAudienceModal(state) {
      state.isShareAudienceModalOpen = false;
      state.profileToShareWith = null;
      state.shareAudienceEmail = "";
      state.selectedAudience = null;
      state.isValidateLoading = false;
      state.isShareValidateEmailSuccess = false;
      state.shareValidateEmailError = null;
    },

    // Share audience:  email validation
    shareValidateEmailRequest(state) {
      state.profileToShareWith = null;
      state.isValidateLoading = true;
      state.isShareValidateEmailSuccess = false;
      state.shareValidateEmailError = null;
    },
    shareValidateEmailSuccess(state, { payload }) {
      state.profileToShareWith = payload;
      state.isValidateLoading = false;
      state.isShareValidateEmailSuccess = true;
      state.shareValidateEmailError = null;
    },
    shareValidateEmailFailure(state, { payload }) {
      state.profileToShareWith = null;
      state.isValidateLoading = false;
      state.shareValidateEmailError = payload;
      state.isShareValidateEmailSuccess = false;
    },

    // Share audience
    shareAudienceRequest(state) {
      state.isShareAudienceLoading = true;
      state.isShareAudienceSuccess = false;
      state.shareError = null;
    },
    shareAudienceSuccess(state) {
      state.isShareAudienceLoading = false;
      state.profileToShareWith = null;
      state.shareAudienceEmail = "";
      state.isShareValidateEmailSuccess = false;
      state.isShareAudienceSuccess = true;
      state.isShareAudienceModalOpen = false;
    },
    shareAudienceFailure(state, { payload }) {
      state.isShareAudienceLoading = false;
      state.profileToShareWith = null;
      state.isShareAudienceSuccess = false;
      state.shareError = payload;
    },

    duplicateAudienceRequest(state) {
      state.isDublicateSuccess = false;
      state.isDubliciting = true;
    },
    duplicateAudienceSuccess(state) {
      state.isDublicateSuccess = true;
      state.isDubliciting = false;
    },
    duplicateAudienceFailure(state) {
      state.isDublicateSuccess = false;
      state.isDubliciting = false;
    },

    fetchRemovedAudiencesRequest(state) {
      state.isRemovedAudiencesLoading = true;
    },
    fetchRemovedAudiencesSuccess(state, { payload }) {
      state.removedAudiences = payload;
      state.isRemovedAudiencesLoading = false;
    },
    fetchRemovedAudiencesFailure(state) {
      state.isRemovedAudiencesLoading = false;
    },

    restoreAllRemovedAudiencesRequest(state) {
      state.isRestoreAllAudiencesSuccess = false;
    },
    restoreAllRemovedAudiencesSuccess(state) {
      state.isRestoreAllAudiencesSuccess = true;
    },
    restoreAllRemovedAudiencesFailure(state) {
      state.isRestoreAllAudiencesSuccess = false;
    },

    restoreAudienceRequest(state) {
      state.isRestoreAudienceSuccess = false;
    },
    restoreAudienceSuccess(state) {
      state.isRestoreAudienceSuccess = true;
    },
    restoreAudienceFailure(state) {
      state.isRestoreAudienceSuccess = false;
    },

    permanentlyRemoveAllRemovedAudiencesRequest(state) {
      state.isPermanentRemoveAllSuccess = false;
    },
    permanentlyRemoveAllRemovedAudiencesSuccess(state) {
      state.isPermanentRemoveAllSuccess = true;
    },
    permanentlyRemoveAllRemovedAudiencesFailure(state) {
      state.isPermanentRemoveAllSuccess = false;
    },

    fetchAudieneMapLayoutRequest(state) {
      state.isMapLayoutLoading = true;
    },
    fetchAudieneMapLayoutSuccess(state, { payload }) {
      state.isMapLayoutLoading = false;
      state.mapLayouts = {
        ...state.mapLayouts,
        [payload.country]: payload.data
      };
    },
    fetchAudieneMapLayoutFailure(state, { payload }) {
      state.isMapLayoutLoading = false;
      state.mapFetchLayoutError = payload;
    }
  }
});

export default audience;
